<ng-container *ngIf="!isVoucherContent; else voucherHeader"
  ><div class="headers-row flex flex-row">
    <div class="flex-[100%] max-w-[60%]">
      {{ '+BOOKING.PLAN.FEATURE.PACKAGE_CONTENT' | translate }}
    </div>
    <div
      data-at-basic-content
      class="flex flex-col justify-start items-center flex-[100%] max-w-[20%]"
    >
      {{ '+BOOKING.PLAN.BASIC_PACKAGE' | translate }}
      <p class="header-description">
        {{ '+BOOKING.PLAN.BASIC_PACKAGE_DESCRIPTION' | translate }}
      </p>
    </div>
    <div
      data-at-pro-content
      class="flex flex-col justify-start items-center flex-[100%] max-w-[20%]"
    >
      {{ '+BOOKING.PLAN.PRO_PACKAGE' | translate }}
      <p class="header-description">
        {{ '+BOOKING.PLAN.PRO_PACKAGE_DESCRIPTION' | translate }}
      </p>
    </div>
  </div></ng-container
>

<ng-template #voucherHeader>
  <div class="headers-row-voucher flex flex-row">
    <div class="header-table-voucher flex-[100%] max-w-[60%]">Feature</div>
    <div class="header-plan-name flex flex-col justify-start items-center flex-[100%] max-w-[20%]">
      {{ '+BOOKING.PLAN.BASIC_PACKAGE' | translate }}
    </div>
    <div class="header-plan-name flex flex-col justify-start items-center flex-[100%] max-w-[20%]">
      {{ '+BOOKING.PLAN.PRO_PACKAGE' | translate }}
    </div>
  </div>
</ng-template>

<div class="package-feature" data-at-package-content-row>
  <div class="feature-title" data-at-package-content-title>
    {{ '+BOOKING.PLAN.FEATURE.QUICK_CHECK_DASHBOARD' | translate }}
    <mat-icon
      data-at-package-content-tooltip-icon
      matTooltipClass="data-at-feature-description"
      inline="true"
      [matTooltip]="'+BOOKING.PLAN.FEATURE.TOOLTIP.QUICK_CHECK_DASHBOARD' | translate"
      >info_outline</mat-icon
    >
  </div>
  <div data-at-package-content-icon class="icon-container"><mat-icon>check</mat-icon></div>
  <div data-at-package-content-icon class="icon-container"><mat-icon>check</mat-icon></div>
</div>
<div class="package-feature" data-at-package-content-row>
  <div class="feature-title" data-at-package-content-title>
    {{ '+BOOKING.PLAN.FEATURE.GUIDED_COMMISSIONING' | translate }}
    <mat-icon
      data-at-package-content-tooltip-icon
      matTooltipClass="data-at-feature-description"
      inline="true"
      [matTooltip]="'+BOOKING.PLAN.FEATURE.TOOLTIP.GUIDED_COMMISSIONING' | translate"
      >info_outline</mat-icon
    >
  </div>
  <div data-at-package-content-icon class="icon-container"><mat-icon>check</mat-icon></div>
  <div data-at-package-content-icon class="icon-container"><mat-icon>check</mat-icon></div>
</div>
<div class="package-feature" data-at-package-content-row>
  <div class="feature-title" data-at-package-content-title>
    {{ '+BOOKING.PLAN.FEATURE.ERROR_LIST' | translate }}
    <mat-icon
      data-at-package-content-tooltip-icon
      matTooltipClass="data-at-feature-description"
      inline="true"
      [matTooltip]="'+BOOKING.PLAN.FEATURE.TOOLTIP.ERROR_LIST' | translate"
      >info_outline</mat-icon
    >
  </div>
  <div data-at-package-content-icon class="icon-container"><mat-icon>check</mat-icon></div>
  <div data-at-package-content-icon class="icon-container"><mat-icon>check</mat-icon></div>
</div>
<div class="package-feature" data-at-package-content-row>
  <div class="feature-title" data-at-package-content-title>
    {{ '+BOOKING.PLAN.FEATURE.BASIC_PARAMETERS' | translate }}
    <mat-icon
      data-at-package-content-tooltip-icon
      matTooltipClass="data-at-feature-description"
      inline="true"
      [matTooltip]="'+BOOKING.PLAN.FEATURE.TOOLTIP.BASIC_PARAMETERS' | translate"
      >info_outline</mat-icon
    >
  </div>
  <div data-at-package-content-icon class="icon-container"><mat-icon>check</mat-icon></div>
  <div data-at-package-content-icon class="icon-container"><mat-icon>check</mat-icon></div>
</div>
<div class="package-feature" data-at-package-content-row>
  <div class="feature-title" data-at-package-content-title>
    <span [ngClass]="{ 'crossed-out': isLegacyDevice }">
      {{ '+BOOKING.PLAN.FEATURE.EXTENDED_PARAMETERS' | translate }}
    </span>
    <div *ngIf="isLegacyDevice; else extendedParametersTooltip" class="incompatible-badge">
      {{ '+BOOKING.PLAN.FEATURE.INCOMPATIBLE' | translate }}
    </div>
    <ng-template #extendedParametersTooltip>
      <mat-icon
        data-at-package-content-tooltip-icon
        matTooltipClass="data-at-feature-description"
        inline="true"
        [matTooltip]="'+BOOKING.PLAN.FEATURE.TOOLTIP.EXTENDED_PARAMETERS' | translate"
        >info_outline</mat-icon
      >
    </ng-template>
  </div>
  <div data-at-package-content-icon class="icon-container">
    <mat-icon class="grey-icon">close</mat-icon>
  </div>
  <div data-at-package-content-icon class="icon-container">
    <mat-icon
      data-at-package-content-tooltip-icon
      matTooltipClass="data-at-feature-description"
      *ngIf="isLegacyDevice; else checkIcon"
      class="yellow-icon"
      >close</mat-icon
    >
    <ng-template #checkIcon>
      <mat-icon>check</mat-icon>
    </ng-template>
  </div>
</div>
<div class="package-feature" data-at-package-content-row>
  <div class="feature-title" data-at-package-content-title>
    <span [ngClass]="{ 'crossed-out': isLegacyDevice }">
      {{ '+BOOKING.PLAN.FEATURE.PARAMETER_COMPARISION' | translate }}
    </span>
    <div *ngIf="isLegacyDevice; else parameterComparisonTooltip" class="incompatible-badge">
      {{ '+BOOKING.PLAN.FEATURE.INCOMPATIBLE' | translate }}
    </div>
    <ng-template #parameterComparisonTooltip>
      <mat-icon
        data-at-package-content-tooltip-icon
        matTooltipClass="data-at-feature-description"
        inline="true"
        [matTooltip]="'+BOOKING.PLAN.FEATURE.TOOLTIP.PARAMETER_COMPARISION' | translate"
        >info_outline</mat-icon
      >
    </ng-template>
  </div>
  <div data-at-package-content-icon class="icon-container">
    <mat-icon class="grey-icon">close</mat-icon>
  </div>
  <div data-at-package-content-icon class="icon-container">
    <mat-icon
      data-at-package-content-tooltip-icon
      matTooltipClass="data-at-feature-description"
      *ngIf="isLegacyDevice; else checkIcon"
      class="yellow-icon"
      >close</mat-icon
    >
    <ng-template #checkIcon>
      <mat-icon data-at-package-content-tooltip-icon>check</mat-icon>
    </ng-template>
  </div>
</div>
<div class="package-feature" data-at-package-content-row>
  <div class="feature-title" data-at-package-content-title>
    {{ '+BOOKING.PLAN.FEATURE.SYSTEM_OVERVIEW' | translate }}
    <mat-icon
      data-at-package-content-tooltip-icon
      matTooltipClass="data-at-feature-description"
      inline="true"
      [matTooltip]="'+BOOKING.PLAN.FEATURE.TOOLTIP.SYSTEM_OVERVIEW' | translate"
      >info_outline</mat-icon
    >
  </div>
  <div data-at-package-content-icon class="icon-container">
    <mat-icon class="grey-icon">close</mat-icon>
  </div>
  <div data-at-package-content-icon class="icon-container"><mat-icon>check</mat-icon></div>
</div>
<div class="package-feature" data-at-package-content-row>
  <div class="feature-title" data-at-package-content-title>
    {{ '+BOOKING.PLAN.FEATURE.TRENDING' | translate }}
    <mat-icon
      data-at-package-content-tooltip-icon
      matTooltipClass="data-at-feature-description"
      inline="true"
      [matTooltip]="'+BOOKING.PLAN.FEATURE.TOOLTIP.TRENDING' | translate"
      >info_outline</mat-icon
    >
  </div>
  <div data-at-package-content-icon class="icon-container">
    <mat-icon class="grey-icon">close</mat-icon>
  </div>
  <div data-at-package-content-icon class="icon-container"><mat-icon>check</mat-icon></div>
</div>
<div class="package-feature" data-at-package-content-row>
  <div class="feature-title" data-at-package-content-title>
    {{ '+BOOKING.PLAN.FEATURE.GUIDED_TROUBLESHOOTING' | translate }}
    <mat-icon
      data-at-package-content-tooltip-icon
      matTooltipClass="data-at-feature-description"
      inline="true"
      [matTooltip]="'+BOOKING.PLAN.FEATURE.TOOLTIP.GUIDED_TROUBLESHOOTING' | translate"
      >info_outline</mat-icon
    >
  </div>
  <div data-at-package-content-icon class="icon-container">
    <mat-icon class="grey-icon">close</mat-icon>
  </div>
  <div data-at-package-content-icon class="icon-container"><mat-icon>check</mat-icon></div>
</div>
<div class="package-feature" data-at-package-content-row>
  <div class="feature-title" data-at-package-content-title>
    {{ '+BOOKING.PLAN.FEATURE.PERMANENT_INSPECTION' | translate }}
    <mat-icon
      data-at-package-content-tooltip-icon
      matTooltipClass="data-at-feature-description"
      inline="true"
      [matTooltip]="'+BOOKING.PLAN.FEATURE.TOOLTIP.PERMANENT_INSPECTION' | translate"
      >info_outline</mat-icon
    >
  </div>
  <div data-at-package-content-icon class="icon-container">
    <mat-icon class="grey-icon">close</mat-icon>
  </div>
  <div data-at-package-content-icon class="icon-container"><mat-icon>check</mat-icon></div>
</div>
<div class="package-feature" data-at-package-content-row>
  <div class="feature-title" data-at-package-content-title>
    {{ '+BOOKING.PLAN.FEATURE.PREDICTIVE_MAINTANANCE' | translate }}
    <mat-icon
      data-at-package-content-tooltip-icon
      matTooltipClass="data-at-feature-description"
      inline="true"
      [matTooltip]="'+BOOKING.PLAN.FEATURE.TOOLTIP.PREDICTIVE_MAINTANANCE' | translate"
      >info_outline</mat-icon
    >
  </div>
  <div data-at-package-content-icon class="icon-container">
    <mat-icon class="grey-icon">close</mat-icon>
  </div>
  <div data-at-package-content-icon class="icon-container"><mat-icon>check</mat-icon></div>
</div>
<div class="package-feature" data-at-package-content-row>
  <div class="feature-title" data-at-package-content-title>
    {{ '+BOOKING.PLAN.FEATURE.AUTOMATED_RECOMMENDATIONS' | translate }}
    <mat-icon
      data-at-package-content-tooltip-icon
      matTooltipClass="data-at-feature-description"
      inline="true"
      [matTooltip]="'+BOOKING.PLAN.FEATURE.TOOLTIP.AUTOMATED_RECOMMENDATIONS' | translate"
      >info_outline</mat-icon
    >
  </div>
  <div data-at-package-content-icon class="icon-container">
    <mat-icon class="grey-icon">close</mat-icon>
  </div>
  <div data-at-package-content-icon class="icon-container"><mat-icon>check</mat-icon></div>
</div>
